export default __webpack_public_path__ + "static/media/House.ef7a8295.png";